<!--  -->
<template>
  <div class="tree-list">
    <el-tree
      v-if="!zoom"
      :render-content="renderContent"
      ref="leftTree"
      class="tree-line"
      node-key="s_id"
      :indent="0"
      :props="props"
      :load="loadNode"
      :expand-on-click-node="false"
      lazy
      @node-click="handleNodeClick"
    >
    </el-tree>
    <right-tree v-if="zoom" :list="list"></right-tree>
  </div>
</template>

<script>
import { getTreeList, utlogMap } from "@/api/index";
import { functionId } from "@/utils/browser.js";
import RightTree from "@/components/tree/rightTreeOrigin";
export default {
  name: "tree-list",
  props: ["nodeId", "zoom"],
  components: {
    RightTree,
  },
  data() {
    return {
      routerName:'',
      tibetName: "TibetPlateau",
      list: [],
      props: {
        label: function (data, node) {
          let p = document.createElement("p");
          p.innerHTML = data.s_en_name;
          let str = p.innerHTML;
          p = null;
          return str;
        },
        children: "children",
        isLeaf: function (data) {
          return !data?.s_has_children;
          //   return false;
        },
        italic: function (data) {
          console.log(data?.s_italic);
        },
      },
    };
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this.routerName = this.$route.name;
  },
  methods: {
    renderContent(h, { node, data, store }) {
      let italic = data.s_italic;
      if (italic) {
        return (
          <span class="el-tree-node__label italic" title={data.s_en_name}>
            {data.s_en_name}
          </span>
        );
      } else {
        return (
          <span class="el-tree-node__label" title={data.s_en_name}>
            {data.s_en_name}
          </span>
        );
      }
    },
    updateNode(list) {
      this.$set(this, "list", list);
    },
    loadNode(node, resolve) {
      let id = node.key;

      getTreeList(id).then((res) => {
        let data = res.data?.data || [];
        data.sort((a, b) => a.s_sort - b.s_sort);
        this.$set(this, "list", data);
        if (id === null) {
          this.$nextTick(() => {
            this.$refs["leftTree"].setCurrentKey(data[0].s_id);
            this.$emit("updateNodeId", data[0].s_id);
          });
        }
        return resolve(data);
      });
      this.logMap();
    },
    logMap() {
      let logMap = {
        eventType: "clk",
        url: window.location.href,
        functionId: (this.routerName == this.tibetName)?'Deepbone_tibet_treeNodeExpand': 'Deepbone_explore_treeNodeExpand',
      };
      return utlogMap(logMap);
    },
    handleNodeClick(data) {
      this.$emit("updateNodeId", data.s_id);
      let logMap = {
        eventType: "clk",
        url: window.location.href,
        functionId: (this.routerName == this.tibetName)?'Deepbone_tibet_treeNodeOpen':'Deepbone_explore_treeNodeOpen',
      };
      utlogMap(logMap).then((res) => {
        // console.log(res);
      });
    },
  },
};
</script>
<style>
.tree-list {
  /* width: 100%;
    height: 100%; */
}
.tree-line .el-tree-node {
  position: relative;
  /* padding-left: 16px; */
}
.tree-line .el-tree-node__children {
  padding-left: 16px;
}

.tree-line .el-tree-node::before {
  content: "";
  height: 100%;
  width: 1px;
  position: absolute;
  left: -3px;
  top: -10px;
  border-width: 1px;
  border-left: 1px solid #dadada;
}
.tree-line .el-tree-node:last-child::before {
  height: 26px;
}
.tree-line .el-tree-node::after {
  content: "";
  width: 11px;
  height: 27px;
  position: absolute;
  left: -3px;
  top: 15px;
  border-width: 1px;
  border-top: 1px solid #dadada;
}
.tree-line > .el-tree-node::after {
  border-top: none;
}
.tree-line > .el-tree-node::before {
  border-left: none;
}
.tree-line .el-tree-node__expand-icon {
  font-size: 16px;
}
.tree-line .el-tree-node__expand-icon.is-leaf {
  color: transparent;
}
.tree-line .el-tree-node__expand-icon.is-leaf::before {
  width: 0;
}
.tree-line .el-tree-node__content > .el-tree-node__expand-icon {
  /* padding: 6px 12px 6px 20px; */
}
.el-tree-node__content {
  /* width: 348px; */
  height: 35px !important;
  font-style: normal;
  font-weight: 500;
  font-size: 32px;
  line-height: 37px;
  color: #484d63;
  background: rgba(255, 255, 255, 0.6);
}

.el-tree-node:focus > .el-tree-node__content,
.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content,
.el-tree-node.is-current > .el-tree-node__content {
  background: #72c2c9 !important;
  color: white !important;
}
.el-tree-node > .el-tree-node__content:hover {
  background: rgba(255, 255, 255, 0.6);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.15);
}
.tree-line .el-icon-caret-right:before {
  content: "";
  display: inline-block;
  width: 18px;
  height: 18px;
  background: url("../../assets/images/plus-square.png") no-repeat center;
  background-size: 18px;
}
.el-tree-node.is-current > .el-tree-node__content .el-icon-caret-right:before {
  background-image: url("../../assets/images/plus-square-white.png");
}
.el-tree-node.is-current
  > .el-tree-node__content
  .el-tree-node__expand-icon.expanded:before {
  background-image: url("../../assets/images/minus-square-white.png") !important;
}
.tree-line .el-tree-node__expand-icon.expanded:before {
  background-image: url("../../assets/images/minus-square.png") !important;
}
.el-icon-loading:before {
  color: white;
}
.tree-line .el-tree-node__label.italic {
  font-style: italic;
}
.tree-line .el-tree-node__expand-icon.is-leaf::before {
  width: 18px !important;
  background: transparent;
}
.el-tree > .el-tree-node {
  display: inline-block;
  min-width: 100%;
}
</style>
